export interface SsoConfig {
  enabled: boolean;
  clientId: string | null;
  tenantId: string | null;
  authority: string | null;
  apiScope: string | null;
}

export interface AppConfig {
  localLoginEnabled: boolean;
  sso: SsoConfig;
}

let cached: AppConfig | null = null;

/** Runtime configuration from the server (/api/config) — never build-time baked. */
export async function loadAppConfig(): Promise<AppConfig> {
  if (cached) return cached;
  const res = await fetch("/api/config");
  if (!res.ok) throw new Error(`Failed to load /api/config: ${res.status}`);
  cached = (await res.json()) as AppConfig;
  return cached;
}
